<template>
    <div id="notifications">
        <div class="flex" v-for="(notification, index) in notifications" v-bind:key="index">
        <span class="bg-dark pl-2 w-100 text-light rounded d-flex justify-content-between">
          <p class="mt-2">
              <i class="fas fa-info-circle"></i> {{ notification.message }}
              <button class="btn btn-sm btn-success ml-3" v-on:click="loadAction(notification.actionLink)">{{ notification.actionText }}</button>
          </p>
          <button type="button" class="btn btn-dark m-1" v-on:click="deleteNotification(index)"><i
                  class="fas fa-times"></i></button>
        </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NotificationBanner",
        template: '#notifications',
        methods: {
            loadAction: function (link) {
                window.open(link, '_blank');
            },
            deleteNotification: function (index) {
                this.notifications.splice(index, 1);
            }
        },
        data: function () {
            return {
                notifications: []
            }
        },
        mounted: function () {
            this.$http.get("/notifications")
                .then(res => {
                    this.notifications = res.data;
                });
        }
    }
</script>